<template>
    <div class="upload">
        <form @submit.prevent="upload">
            <input type="file" ref ="fileInput" @change="onFileSelected" >
        <button> Submit</button>
        </form>
         <!-- <form @submit.prevent="deleteFile">
        <button> Submit</button>
         </form> -->
    </div>
</template>
<script>
import firebase from "firebase"



export default {
    name :"Upload",
    data(){
        return{
            image:null
        }
    },
    methods:{
        onFileSelected(event){
            
            this.image = event.target.files[0]
        
        },
        upload(){
            if (this.image){
                console.log("true")
            }else{
               console.log("false")
            }
        }

//              var file = this.image
//            console.log(this.image)
//             var storage = firebase.storage();
//            var storageRef = firebase.storage().ref("places/"+ file.name )
          
           
//                 storageRef.put(file).then(function(snapshot) {
//                 console.log('Uploaded a blob or file!');
//             }).then(()=>{
//                  storageRef.getDownloadURL().then(function(url) {
//                   console.log(url);
//                  })
//             })
//            this.$router.push({name:"Index"})
//         },
//     deleteFile(){
//          var storage = firebase.storage();
//         var removeRef = firebase.storage().ref("places/crpdins_20180723_230653.jpg" )
//         removeRef.delete().then(function() {
//   console.log("File deleted successfully")
// }).catch(function(error) {
//  console.log("Uh-oh, an error occurred!") 
// });

//     }
//     }
}}
</script>




// WEBPACK FOOTER //
// src/components/Upload.vue